import { useTranslation } from "react-i18next";
import TextField from "@/components/layouts/History/TextField";
import { usePartnerContacts } from "@/pages/partners/contacts/hooks";
import { getPartnerContactFullName } from "@/pages/partners/contacts/helpers";
import { toIdList } from "@/entities/history/helpers";
import { logFieldValue } from "@/entities/history/types";
import { map } from "lodash";

interface PartnerContactNameProps {
  value: logFieldValue;
}

// Handles both the scalar reference (partner_contact_id) and the array-valued
// partners.partner_contacts
const PartnerContactName: React.FC<PartnerContactNameProps> = ({ value }) => {
  const { t } = useTranslation();
  const contactIds = toIdList(value);
  const { entities: contacts, isLoading } = usePartnerContacts(contactIds, {
    enabled: contactIds.length > 0
  });

  if (contactIds.length === 0) return null;

  const names = map(contacts, (contact) =>
    contact ? getPartnerContactFullName(contact) : ""
  )
    .filter(Boolean)
    .join(", ");

  // See PartnerName — unresolved ids fall back to "unknown", but only once the
  // lookup has settled
  if (!names) return isLoading ? null : <TextField>{t("unknown")}</TextField>;

  return <TextField>{names}</TextField>;
};

export default PartnerContactName;
